import { useEffect } from 'react';
import { useDataVaultStore } from '@/store/dataVault';

/**
 * Keyboard shortcuts for the Data Vault page.
 *
 * | Shortcut | Action                |
 * |----------|-----------------------|
 * | Escape   | Clear cross-filter    |
 * | Ctrl+E   | Open export menu      |
 * | Ctrl+1   | Switch to Chemistry   |
 * | Ctrl+2   | Switch to Water-Levels|
 * | Ctrl+3   | Switch to Compliance  |
 */
export function useDataVaultShortcuts(opts?: {
  onOpenExport?: () => void;
}) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      // Don't fire inside inputs/textareas
      const tag = (e.target as HTMLElement)?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;

      const store = useDataVaultStore.getState();

      // Escape — clear cross-filter
      if (e.key === 'Escape') {
        const isActive = !!(store.crossFilter.well || store.crossFilter.date || store.crossFilter.analyte);
        if (isActive) {
          e.preventDefault();
          store.clearCrossFilter();
        }
        return;
      }

      // Ctrl+E — open export menu
      if (e.ctrlKey && e.key === 'e') {
        e.preventDefault();
        opts?.onOpenExport?.();
        return;
      }

      // Ctrl+1/2/3 — switch data source
      if (e.ctrlKey && !e.shiftKey && !e.altKey) {
        if (e.key === '1') {
          e.preventDefault();
          store.setDataSource('chemistry');
        } else if (e.key === '2') {
          e.preventDefault();
          store.setDataSource('water-levels');
        } else if (e.key === '3') {
          e.preventDefault();
          store.setDataSource('compliance');
        }
      }
    };

    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [opts?.onOpenExport]);
}
